<template>
  <footer v-if="!isRedirect">
    <div class="wrapper">
    <div class="left">
      <p><img class="ico" src="@/assets/svg/location.svg"/>北京市朝阳区惠河南街南岸一号礼安门A座</p>
      <p><img class="ico" src="@/assets/svg/company.svg"/>北京新橙科技有限公司</p>
      <p class="notice" @click="viewNotice()"><span class="one one-menu-evidence"></span>
        <a>数据利用提醒</a>
      </p>
      <p>Copyright © 2020 All</p>
    </div>
    <div class="right">
      <div>
        <img src="/img/qrcode.png" alt="">
        <p>扫码下载线上课程APP</p>
      </div>
      <div>
        <img src="/img/mini-program-code.jpg" alt="">
        <p>关注线上课程小程序</p>
      </div>
    </div>
    </div>
    <Modal v-model="noticeShow" width="460" class-name="vertical-center-modal">
      <p slot="header" style="color:#ED6C00;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>数据利用提醒</span>
      </p>
      <div style="text-align:left">
        <p>
          亲爱的企业法律服务中台超级校友，期待我们研发的对企营销内容数据库能够助力您的市场拓展。
          <br>
          建议您对下载的资料进行个性化的修订，以更加符合您团队开展业务、服务客户的实际需要。同时，数据库里的数据内容，仅供企业法律服务中台超级校友使用，请您妥善使用与保管。</p>
      </div>
      <div slot="footer"></div>
    </Modal>
  </footer>
</template>
<script>
import { FISCAL_TAX, CCC } from '@/constant/constants'
export default {
  data () {
    return {
      noticeShow: false,
      isRedirect: sessionStorage.getItem('redirectType') === FISCAL_TAX || sessionStorage.getItem('redirectType') === CCC,
    }
  },
  methods: {
    viewNotice () {
      this.noticeShow = true
    },
  },
}
</script>
<style lang="scss" scoped>
  /deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
      top: 0;
    }
  }
  footer {
    width: 100%;
    min-width: 1280px;
    height: 200px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin-top: 2px;
    .wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1200px;
    }
    .left {
      i {
        font-size: 16px;
        margin-right: 8px;
      }
      .ico {
        width: 12px;
        height: 12px;
        margin-right: 8px;
      }
      p {
        display: flex;
        align-items: center;
        font-size: 12px;
        color:  #6A6A6A;
      }
    }
    .right {
      display: flex;
      text-align: center;
      img {
        width: 80px;
        height: 80px;
      }
      & > div:not(:last-of-type) {
        margin-right: 40px;
      }
    }
    p {
      padding: 5px 0px;
      &.notice{
        cursor: pointer;
        font-size: 12px;
        .one{
          display: inline-block;
          transform: translate(-1px, 2px);
          font-size: 14px;
          margin-right: 8px;
          color:  #B1B1B1;
        }
        a{
          text-decoration: underline;
          color:  #6A6A6A;
        }
        &:hover{
          color: #ed6c00;
        }
      }
    }
  }
</style>
